/* 
 * Export component file to be used on project
*/

import Tabs from './Tabs.js';
export default Tabs;
